






















































import { Vue, Component, Prop, p, Mixin } from "av-ts";
import { IQuestion } from "../../interfaces/models";

import QuestionPreview from "./QuestionPreview.vue";
import responsiveMixin from "../../responsiveMixin";


@Component({
    components: {
        QuestionPreview
    }
})
export default class QuestionCards extends mixin(responsiveMixin, Vue) {

    @Prop questions = p<IQuestion[]>({
        default: []
    });

    @Prop returnTo = p<string>({
        default: "answer"
    });

    @Prop loadUserID = p<string>({});

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/questions/QuestionCards.vue